﻿(function () {
  function customizeJudgeMe() {
    const widget = document.querySelector("#judgeme_product_reviews");
    if (!widget) return;

    const reviewHeaders = widget.querySelectorAll(".jdgm-rev__header");

    reviewHeaders.forEach((header) => {
      if (header.dataset.ratingCustomized) return;

      const rowRating = header.querySelector(".jdgm-row-rating");
      const rowProfile = header.querySelector(".jdgm-row-profile");

      const rating = rowRating?.querySelector(".jdgm-rev__rating");
      const timestamp = rowRating?.querySelector(".jdgm-rev__timestamp");

      if (!rowProfile || !rating || !timestamp) return;

      const ratingWrapper = document.createElement("div");
      ratingWrapper.className = "custom-review-rating";

      const score = rating.getAttribute("data-score") || "0";
      const scoreEl = document.createElement("span");
      scoreEl.className = "custom-review-score";
      scoreEl.textContent = score;

      ratingWrapper.appendChild(scoreEl);
      ratingWrapper.appendChild(rating);

      rowProfile.appendChild(timestamp);
      rowProfile.appendChild(ratingWrapper);

      header.dataset.ratingCustomized = "true";
    });

    if (widget.dataset.customized) return;

    const header = widget.querySelector(".jdgm-rev-widg__header");
    const reviewsBody = widget.querySelector(".jdgm-rev-widg__body");

    if (!header || !reviewsBody) return;

    widget.dataset.customized = "true";
    widget.classList.add("custom-review-layout");

    const histogram = header.querySelector(".jdgm-histogram");
    if (histogram) histogram.classList.remove("jdgm-temp-hidden");

    const wrapper = document.createElement("div");
    wrapper.className = "custom-review-wrapper";

    header.parentNode.insertBefore(wrapper, header);
    wrapper.appendChild(header);
    wrapper.appendChild(reviewsBody);
  }

  customizeJudgeMe();

  const observer = new MutationObserver(() => {
    customizeJudgeMe();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
